import React from "react";

/**
 * Reusable Rider/Add-on card component.
 * Default landing: show defaultPremiumLabel (e.g. "Starts @ ₹22"). When add-on is selected, show actual premium from API.
 */
const RiderCard = ({
  rider,
  isSelected,
  riderPremium,
  premiumFrequency = "Yearly",
  defaultPremiumLabel = "Starts @ ₹22",
  coverValue,
  coverOptions,
  onToggle,
  onCoverChange,
}) => {
  const isPlusRider = rider.id === "accidental-death-disability-plus";
  const hasActualPremium = riderPremium != null && riderPremium !== "";
  const premiumLabel = hasActualPremium
    ? `₹${Number(riderPremium).toLocaleString("en-IN")}`
    : defaultPremiumLabel;
  const frequencyLabel = (premiumFrequency || "Yearly").toLowerCase();
  const showFrequency = hasActualPremium;
  return (
    <div className="rider-card">
      <div className="rider-header">
        <h6 className="rider-title m-0">{rider.name}</h6>
        <span className="rider-premium">
          <span className="text-bold">{hasActualPremium ? "@ " : ""}{premiumLabel}</span>
          {showFrequency ? ` / ${frequencyLabel}` : ""}
        </span>
      </div>
      <div className="rider-description">
        <p>
          <span>In case of death due to accident, an additional cover amount will be
            paid to</span>
          <button className="know-more-link-inline btn tertiary-button small p-0">Know More</button>
        </p>
      </div>
      <div className="rider-cover-footer">
        <div className="rider-cover-selector">
          <label>Cover</label>
          {isPlusRider ? (
            <input
              type="text"
              className="rider-cover-dropdown"
              value={coverValue ? `₹ ${coverValue}` : ""}
              readOnly
              disabled
            />
          ) : (
          <select
            className="rider-cover-dropdown"
            value={coverValue}
            onChange={(e) => onCoverChange(rider.id, e.target.value)}
          >
            {coverOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          )}
        </div>
        <button
          className={`rider-action-button btn secondary-button small ${isSelected ? "added" : ""}`}
          onClick={() => onToggle(rider.id)}
        >
          {isSelected ? (
            <>
              Added
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="8" cy="8" r="8" fill="#97262A" />
                <path
                  d="M10.9068 5.59364C10.7898 5.4766 10.6002 5.4766 10.4835 5.59364L6.50329 9.57382L5.51698 8.58818C5.40027 8.47114 5.21034 8.47114 5.09364 8.58818C4.9766 8.70521 4.9766 8.89481 5.09364 9.01152L6.25415 10.172C6.28495 10.2028 6.32123 10.2244 6.35955 10.2391C6.40713 10.2682 6.4588 10.2877 6.51253 10.2877C6.58918 10.2877 6.66585 10.2586 6.72437 10.2001L10.9068 6.01733C11.0238 5.90029 11.0238 5.71069 10.9068 5.59366V5.59364H10.9068Z"
                  fill="white"
                />
              </svg>
            </>
          ) : (
            <>
              Add
              <svg
                width="13"
                height="13"
                viewBox="0 0 13 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.5 6.25C12.5 6.44891 12.421 6.63968 12.2803 6.78033C12.1397 6.92098 11.9489 7 11.75 7H7V11.75C7 11.9489 6.92098 12.1397 6.78033 12.2803C6.63968 12.421 6.44891 12.5 6.25 12.5C6.05109 12.5 5.86032 12.421 5.71967 12.2803C5.57902 12.1397 5.5 11.9489 5.5 11.75V7H0.75C0.551088 7 0.360322 6.92098 0.21967 6.78033C0.0790177 6.63968 0 6.44891 0 6.25C0 6.05109 0.0790177 5.86032 0.21967 5.71967C0.360322 5.57902 0.551088 5.5 0.75 5.5H5.5V0.75C5.5 0.551088 5.57902 0.360322 5.71967 0.21967C5.86032 0.0790177 6.05109 0 6.25 0C6.44891 0 6.63968 0.0790177 6.78033 0.21967C6.92098 0.360322 7 0.551088 7 0.75V5.5H11.75C11.9489 5.5 12.1397 5.57902 12.2803 5.71967C12.421 5.86032 12.5 6.05109 12.5 6.25Z"
                  fill="#97262A"
                />
              </svg>
            </>
          )}
        </button>
      </div>
    </div>
  )
};

export default React.memo(RiderCard);
